import { isEmpty } from "lodash";
import { AnimatePresence, motion } from "framer-motion";
import SportBookOdds from "./SportBookOdds";
import { useContextSelector } from "use-context-selector";
import ThemeContext from "../../context/ThemeContext";
const SportBookMatchInner = ({
  updatedData,
  parly,

  betSlipObject,
  handelChange,
  setSelected,
  showBetDialog,
  sportBookCheck,
  parlyBet,
  detail,
  position,
  setActive,
  active,
  selected,
  addToFavioute,
  favouriteList,
}) => {
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  return updatedData?.length > 0 ? (
    updatedData?.map((item, index) => {
      if (item?.sportsBookSelection?.length > 0) {
        let lockOuter =
          item?.apiSiteStatus == "SUSPENDED" || item?.marketStatus != 1;
        let animate = favouriteList?.includes(item.id);
        return (
          <div className="s-mb-3px">
            <AnimatePresence>
              <motion.div
                key={item.id}
                layout={animate} // Animate only clicked item
                initial={animate ? { opacity: 0, y: 10 } : false}
                animate={animate ? { opacity: 1, y: 0 } : {}}
                exit={{ opacity: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 500,
                  damping: 30,
                  mass: 0.5,
                }}
              >
                <div
                  onClick={() =>
                    setActive((prev) => {
                      if (prev.includes(index)) {
                        return prev?.filter((obj) => {
                          return obj != index;
                        });
                      } else {
                        return [...prev, index];
                      }
                    })
                  }
                  style={
                    theme == "light"
                      ? { background: "#20232a", color: "white" }
                      : {}
                  }
                  className="s-relative s-py-2 s-pl-0 s-mb-3px s-flex s-justify-start s-items-center s-rounded-t-4px s-bg-black-100 dark:s-bg-secondary dark:s-text-global-font-default-dark s-min-h-35px"
                >
                  <div
                    data-v-5460a16b
                    className="s-fav s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-16px s-ml-7px s-mr-4px"
                  >
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        addToFavioute(detail?.eventId, "SportBook", item?.id);
                      }}
                      data-v-5460a16b
                      className={`s-relative s-icon-star${
                        animate ? "-solid s-animate-star-line-box" : ""
                      }`}
                    >
                      <span
                        data-v-5460a16b
                        className={`s-rating-star-line s-bg-global-font-default-light dark:s-bg-global-font-default-dark ${
                          animate ? "s-animate-star-line" : ""
                        }`}
                      />
                      <span
                        data-v-5460a16b
                        className={`s-rating-star-line s-bg-global-font-default-light dark:s-bg-global-font-default-dark ${
                          animate ? "s-animate-star-line" : ""
                        }`}
                      />
                      <span
                        data-v-5460a16b
                        className={`s-rating-star-line s-bg-global-font-default-light dark:s-bg-global-font-default-dark ${
                          animate ? "s-animate-star-line" : ""
                        }`}
                      />
                    </div>
                  </div>
                  <span className="s-text-16px s-leading-120 s-pl-3px s-pr-2 s-flex-1">
                    {item?.marketName}
                  </span>
                  <span
                    className={`s-icon-arrow-down-sencodary s-text-12px s-mr-3 s-justify-self-end s-text-global-font-default-light dark:s-text-global-font-default-dark s-transition-transform s-origin-center s-duration-300 s-transform ${
                      active?.includes(index) ? "s-rotate-180" : ""
                    } `}
                  />
                </div>
                {active?.includes(index) && (
                  <div className="s-grid s-grid-cols-2 s-gap-1px s-relative">
                    {item?.sportsBookSelection?.map((res, id) => {
                      if (Number(res?.odds) > 0) {
                        let newPosition = "";
                        if (
                          showBetDialog &&
                          betSlipObject?.playType == "sportBook" &&
                          item?.id == selected
                        ) {
                          let backProfit =
                            (Number(betSlipObject?.odds) - 1) *
                            Number(betSlipObject?.bidPrice);
                          let backLoss = Number(betSlipObject?.bidPrice);
                          if (res?.id == betSlipObject?.object?.id) {
                            newPosition =
                              Math.abs(res?.position) > 0
                                ? Number(backProfit) + Number(res.position)
                                : Number(backProfit);
                          } else {
                            newPosition =
                              Math.abs(res?.position) > 0
                                ? Number(res?.position) - Number(backLoss)
                                : -Number(backLoss);
                          }
                        }
                        let activeClass = parly
                          ? sportBookCheck(parlyBet, detail, res)
                          : betSlipObject?.teamName == res?.selectionName &&
                            betSlipObject?.odds == res?.odds &&
                            item?.marketName ==
                              betSlipObject?.item?.marketName &&
                            showBetDialog;
                        let conditionShowPositon = !isEmpty(
                          position?.find((res) => {
                            return (
                              res?.marketId ==
                              `${item?.betfairEventId}S${item?.id}`
                            );
                          }),
                        );
                        let conditionPosition =
                          showBetDialog &&
                          betSlipObject?.playType == "sportBook" &&
                          item?.id == selected &&
                          Number(betSlipObject?.bidPrice) > 0
                            ? true
                            : false;
                        let lock =
                          res?.isActive != 1 ||
                          item?.apiSiteStatus == "SUSPENDED" ||
                          item?.marketStatus != 1;

                        let oldObject = item?.oldSportsBookSelection?.find(
                          (obj) => {
                            return obj?.id == res?.id;
                          },
                        );

                        return (
                          <div
                            onClick={(e) => {
                              if (!lock) {
                                handelChange(res?.odds, item, res, e);
                                setSelected(item?.id);
                              }
                            }}
                            data-v-fae226aa
                            className={`s-py-1.5 s-text-center s-flex s-flex-col s-justify-center s-items-center s-bg-back-200 dark:s-bg-back-400-dark s-min-0 s-relative s-overflow-hidden s-rounded-b-md s-min-h-53px ${
                              res?.odds != oldObject?.odds
                                ? "s-animate-spark-back"
                                : ""
                            }  ${activeClass ? "back-active" : ""}`}
                            title="back"
                          >
                            <p
                              data-v-fae226aa
                              className="s-text-17px s-font-bold s-pb-1 s-px-1 s-text-black-900"
                            >
                              {res?.selectionName}
                            </p>

                            <SportBookOdds
                              res={res}
                              parly={parly}
                              conditionPosition={conditionPosition}
                              newPosition={newPosition}
                              conditionShowPositon={conditionShowPositon}
                            />
                          </div>
                        );
                      }
                    })}
                    {lockOuter && (
                      <div className="s-absolute s-w-full s-h-full s-bg-black-700 dark:s-bg-black-900 s-opacity-80 s-rounded-b-3px s-z-20">
                        <span className="s-w-full s-h-full s-flex s-justify-center s-items-center s-text-white s-text-15px">
                          Suspend
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          </div>
        );
      }
    })
  ) : (
    <div class="s-bg-white s-rounded-b-xl dark:s-bg-market-tab-bg-active">
      <div class="s-bg-market-tab-active s-h-3px"></div>
      <div class="s-py-3 s-px-4 s-text-14px dark:s-text-black-500">
        Loading Market…
      </div>
    </div>
  );
};

export default SportBookMatchInner;
